// extracted by mini-css-extract-plugin
export default {"dialog":"new-account-dialog_dialog__Ne9uF"};